module.exports = __webpack_public_path__ + "static/media/5.9ad9b477.png";